import * as React from 'react';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';

import Backdrop from '@mui/material/Backdrop';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import Person4Icon from '@mui/icons-material/Person4';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import KeyIcon from '@mui/icons-material/Key';
import LogoutIcon from '@mui/icons-material/Logout';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import zIndex from '@mui/material/styles/zIndex';
import { Height } from '@mui/icons-material';
import { cyan } from '@mui/material/colors';

import { useUser } from "../context/UserContext";
import { useNavigate, useLocation } from "react-router-dom";

const theme = createTheme({
    typography: {
        fontSize: 12, // Cambia la escala base de la tipografía (16px por defecto)
    },
    palette: {
        primary: {
            main: "#ffffff",
            light: "#ffffff",
            dark: "#ffffff",
            contrastText: "#00bcd4",
        },
        secondary: {
            main: '#81c784',
        },
        white: {
            main: "#000000",
            light: "#000000",
            dark: "#000000",
            contrastText: "#000000",
        },
        white2: {
            main: "#ffffff",
            light: "#ffffff",
            dark: "#ffffff",
            contrastText: "#ffffff",
        }
    },
});

const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
    position: 'absolute',
    '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
        top: theme.spacing(2),
        left: theme.spacing(2),
    },
}));


export default function SpeedDialTooltipOpen() {
    const { user, logout } = useUser();
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    // console.log(location.pathname);

    return (
        <Box style={{ height: "auto", width: "100%", position: "absolute !important", top: "10px", left: "10px", zIndex: "9999 !important", alignItems: "flex-end !important" }}>
            <ThemeProvider theme={theme}>
                <Backdrop open={open} />
                <StyledSpeedDial
                    ariaLabel="SpeedDial tooltip example"
                    style={{ position: 'absolute', top: 10, right: 10, alignItems: "flex-end" }}
                    icon={<Person4Icon />}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    color='secondary'
                    open={open}
                    direction="down"
                    sx={{
                        '& .MuiFab-root': { // Sobrescribir el estilo del botón principal
                            boxShadow: 'none', // Quitar sombra
                            '&:hover': {
                                boxShadow: 'none', // También quitar sombra al pasar el mouse
                            }
                        }
                    }}
                >
                    {location.pathname !== "/dashboard" &&
                        <SpeedDialAction
                            tooltipTitle='Proyectos'
                            tooltipOpen
                            onClick={handleClose}
                            icon={<FolderCopyIcon onClick={() => { navigate("/dashboard"); }} />}
                        />
                    }
                    {location.pathname !== "/usuarios" &&
                        user.rol === "admin" &&
                        <SpeedDialAction
                            tooltipTitle='Usuarios'
                            tooltipOpen
                            onClick={handleClose}
                            icon={<PeopleAltIcon onClick={() => { navigate("/usuarios"); }} />}
                        />
                    }
                    {/* <SpeedDialAction
                        tooltipTitle='Mi_Perfil'
                        tooltipOpen
                        onClick={handleClose}
                        icon={<Person4Icon />}
                    />
                    <SpeedDialAction
                        tooltipTitle='Contraseña'
                        tooltipOpen
                        onClick={handleClose}
                        icon={<KeyIcon />}
                    /> */}
                    <SpeedDialAction
                        tooltipTitle='Logout'
                        tooltipOpen
                        onClick={handleClose}
                        icon={<LogoutIcon onClick={logout} />}
                    />


                </StyledSpeedDial>
            </ThemeProvider>
        </Box>
    );
}